module.exports = __webpack_public_path__ + "img/position.9cd3e255.png";